export function ucfirst(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}

export function anonymizeEmail(email: string): string {
    const [local, domain] = email.split('@');
    const masked = local.slice(1, -1).replaceAll(/./g, '*')

    return `${local[0]}${masked}${local.at(-1)}@${domain}`;
}
